import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "SubmitReview" }
const _hoisted_2 = {
  key: 0,
  class: "SubmitReviewContainer"
}
const _hoisted_3 = {
  key: 0,
  class: "SubmitReviewNotification"
}
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubmitReviewModal = _resolveComponent("SubmitReviewModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.wasReviewSubmitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.notificationClosed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.canSubmitReview)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Have you completed the review? Go ahead and submit it! ")
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Please go over all the enrolments before submitting your review. ")
                    ], 64 /* STABLE_FRAGMENT */)),
                _createElementVNode("button", {
                  class: "NotificationCloseButton SubmitReviewNotificationCloseButton",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeNotification()))
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "lnr-cross" }, null, -1 /* CACHED */)
                ]))])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            class: _normalizeClass({
					NavigatorButton: !_ctx.canSubmitReview,
					'ChampionButton SubmitReviewButton': _ctx.canSubmitReview,
					RequestSubmitReviewButton: true
				}),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.requestSubmitReviewConfirmation())),
            disabled: !_ctx.canSubmitReview
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "lnr-clipboard-check" }, null, -1 /* CACHED */),
            _createElementVNode("span", null, "Submit review", -1 /* CACHED */)
          ]))], 10 /* CLASS, PROPS */, _hoisted_4)
        ]))
      : _createCommentVNode("v-if", true),
    (!_ctx.submitReviewModalStatusIsInactive)
      ? (_openBlock(), _createBlock(_component_SubmitReviewModal, {
          key: 1,
          modalStatus: _ctx.modalStatusSubmitReview,
          onHideModal: _ctx.hideModal
        }, null, 8 /* PROPS */, ["modalStatus", "onHideModal"]))
      : _createCommentVNode("v-if", true)
  ]))
}